import React, { useState, useEffect } from 'react';
import { Filter, Search, Star, MapPin, TrendingUp, Flame, Award, Heart, Eye, ThumbsUp, Package,ChevronDown, Bell, Zap, Target, Sparkles,  ChevronLeft, ChevronRight, ChevronsLeft, ChevronsRight, Menu, X } from 'lucide-react';
import { ReviewCard } from "../components/ReviewCard";
import { ProductCard } from "../components/ProductCard";
import { products, users } from '../data/data';
import { useNavigate } from 'react-router-dom';
import { ApiService } from '../services/productService';
import { ProductSubmissionModal } from '../modals/ProductSubmissionModal';
import API_URL from '../config/ApiUrl';
import { useUser } from '../context/UserContext';
import { getProductImage } from '../static/ProductPlaceHolder';
import { DispensarySubmissionModal } from '../dispensary/DispensarySubmissionModal';
import { TrendingSidebar } from '../components/TrendingSidebar';
import { FindNearbyModal } from '../dispensary/NearbyDispensaryModal';
import { getSmokerEmoji } from '../static/SmokerEmoji';
import { useTheme } from '../arrangement/ThemeContext';
import { useLocation } from 'react-router-dom';

const dealsSidebar = [
  { dispensary: "CloudNine", deal: "20% off first order", expires: "2 days" },
  { dispensary: "GreenLeaf Co", deal: "Buy 2 get 1 free edibles", expires: "5 days" },
  { dispensary: "TechTerps", deal: "Free delivery over $75", expires: "ongoing" }
];

const EnhancedProductCard = ({ product, onWishlist, onQuickView, colors }) => {
  const [isWishlisted, setIsWishlisted] = useState(false);
  const [showQuickView, setShowQuickView] = useState(false);
  const navigate = useNavigate();

  const handlePriceFilterWithRealPricing = (products, priceMin, priceMax) => {
    return products.filter(product => {
      let actualPrice;
      
      // Use real pricing if available, otherwise use fallback
      if (product.pricing?.has_pricing && product.pricing.average_price) {
        actualPrice = product.pricing.average_price;
      } else {
        const basePrices = { 'flower': 35, 'cart': 65, 'edible': 25, 'pre-roll': 15 };
        actualPrice = basePrices[product.type] || 30;
      }
      
      if (priceMin && actualPrice < priceMin) return false;
      if (priceMax && actualPrice > priceMax) return false;
      
      return true;
    });
  };

  // Tooltip component for price information
  const PriceTooltip = ({ product }) => {
    if (!product.pricing?.has_pricing) {
      return (
        <div style={{
          position: 'absolute',
          bottom: '100%',
          left: '50%',
          transform: 'translateX(-50%)',
          background: colors.comeCard,
          border: '1px solid #333',
          borderRadius: '8px',
          padding: '8px 12px',
          fontSize: '12px',
          color: '#e5e5e5',
          whiteSpace: 'nowrap',
          zIndex: 10
        }}>
          Estimated price
        </div>
      );
    }
    
    return (
      <div style={{
        position: 'absolute',
        bottom: '100%',
        left: '50%',
        transform: 'translateX(-50%)',
        background: colors.comeCard,
        border: '1px solid #333',
        borderRadius: '8px',
        padding: '8px 12px',
        fontSize: '12px',
        color: '#e5e5e5',
        zIndex: 10,
        minWidth: '200px'
      }}>
        <div style={{ fontWeight: '600', marginBottom: '4px', color: '#00d4aa' }}>
          Real Dispensary Prices
        </div>
        <div>Average: ${product.pricing.average_price}</div>
        <div>Range: ${product.pricing.min_price} - ${product.pricing.max_price}</div>
        <div style={{ fontSize: '10px', color: '#888', marginTop: '4px' }}>
          From {product.pricing.location_count} dispensaries
        </div>
      </div>
    );
  };
  
  const handleProductClick = (e) => {
    if (e.target.closest('button')) {
      return;
    }
    navigate(`/products/${product.id}`);
  };

  const handleWishlist = (e) => {
    e.stopPropagation();
    setIsWishlisted(!isWishlisted);
    onWishlist(product.id);
  };

  return (
    <div
      onClick={handleProductClick}
      style={{
        backgroundColor: '#1a1a1a',
        borderRadius: '20px',
        border: '1px solid #333',
        overflow: 'hidden',
        transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
        position: 'relative',
        cursor: 'pointer'
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = 'translateY(-8px)';
        e.currentTarget.style.boxShadow = '0 20px 40px -12px rgba(0, 0, 0, 0.4)';
        e.currentTarget.style.borderColor = '#00d4aa';
        setShowQuickView(true);
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = 'translateY(0)';
        e.currentTarget.style.boxShadow = '0 4px 6px -1px rgba(0, 0, 0, 0.3)';
        e.currentTarget.style.borderColor = '#333';
        setShowQuickView(false);
      }}
    >
      {/* Status Badges */}
      <div style={{ position: 'absolute', top: '12px', left: '12px', zIndex: 2, display: 'flex', flexDirection: 'column', gap: '4px' }}>
        {product.trending && (
          <div style={{
            background: 'linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%)',
            color: 'white',
            padding: '4px 8px',
            borderRadius: '12px',
            fontSize: '10px',
            fontWeight: '600',
            display: 'flex',
            alignItems: 'center',
            gap: '4px'
          }}>
            <TrendingUp size={10} />
            TRENDING
          </div>
        )}
        {product.hot && (
          <div style={{
            background: 'linear-gradient(135deg, #ef4444 0%, #dc2626 100%)',
            color: 'white',
            padding: '4px 8px',
            borderRadius: '12px',
            fontSize: '10px',
            fontWeight: '600',
            display: 'flex',
            alignItems: 'center',
            gap: '4px'
          }}>
            <Flame size={10} />
            HOT
          </div>
        )}
        {product.newArrival && (
          <div style={{
            background: 'linear-gradient(135deg, #00d4aa 0%, #10b981 100%)',
            color: '#0a0a0a',
            padding: '4px 8px',
            borderRadius: '12px',
            fontSize: '10px',
            fontWeight: '600',
            display: 'flex',
            alignItems: 'center',
            gap: '4px'
          }}>
            <Sparkles size={10} />
            NEW
          </div>
        )}
      </div>

      {/* Product Image */}
      <div style={{ position: 'relative', aspectRatio: '1', overflow: 'hidden' }}>
        <img
          src={product.image}
          alt={product.name}
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            transition: 'transform 0.3s ease'
          }}
          onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.05)'}
          onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
        />
        
        {!product.inStock && (
          <div style={{
            position: 'absolute',
            inset: 0,
            background: 'rgba(0, 0, 0, 0.7)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: 'white',
            fontWeight: '600',
            fontSize: '18px'
          }}>
            OUT OF STOCK
          </div>
        )}

        {showQuickView && product.inStock && (
          <div 
          onClick={handleProductClick}
          style={{
            position: 'absolute',
            bottom: '12px',
            left: '12px',
            right: '12px',
            background: 'linear-gradient(135deg, #00d4aa 0%, #10b981 100%)',
            color: '#0a0a0a',
            padding: '8px 16px',
            borderRadius: '8px',
            fontWeight: '600',
            fontSize: '14px',
            textAlign: 'center',
            opacity: showQuickView ? 1 : 0,
            transform: showQuickView ? 'translateY(0)' : 'translateY(20px)',
            transition: 'all 0.3s ease'
          }}>
            Quick View
          </div>
        )}
      </div>

      {/* Product Details */}
      <div style={{ padding: '16px' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
          <span style={{ fontSize: '12px', color: '#888', fontWeight: '500' }}>{product.brand}</span>
          <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
            <MapPin size={10} style={{ color: '#00d4aa' }} />
            <span style={{ fontSize: '10px', color: '#00d4aa', fontWeight: '500' }}>{product.dispensaryDistance}</span>
          </div>
        </div>

        <h3 style={{
          fontSize: '16px',
          fontWeight: '600',
          color: '#e5e5e5',
          marginBottom: '8px',
          lineHeight: '1.3',
          height: '40px',
          overflow: 'hidden',
          display: '-webkit-box',
          WebkitLineClamp: 2,
          WebkitBoxOrient: 'vertical'
        }}>
          {product.name}
        </h3>

        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '12px' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
            <Star size={14} style={{ color: '#fbbf24', fill: '#fbbf24' }} />
            <span style={{ fontWeight: '600', color: '#e5e5e5' }}>{product.rating}/5</span>
          </div>
          <span style={{ fontSize: '12px', color: '#888' }}>({product.reviewCount})</span>
          {/* <div style={{
            marginLeft: 'auto',
            display: 'flex',
            alignItems: 'center',
            gap: '4px',
            fontSize: '12px',
            color: '#888'
          }}>
            <Eye size={10} />
            {product.wishlistCount}
          </div> */}
        </div>

        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '12px' }}>
          <div style={{
            background: 'linear-gradient(135deg, rgba(0, 212, 170, 0.2) 0%, rgba(16, 185, 129, 0.2) 100%)',
            color: '#00d4aa',
            padding: '4px 8px',
            borderRadius: '8px',
            fontSize: '12px',
            fontWeight: '600'
          }}>
            {product.thc}% THC
          </div>
          <span style={{ fontSize: '12px', color: '#888', backgroundColor: '#2a2a2a', padding: '4px 8px', borderRadius: '8px' }}>
            {product.category}
          </span>
        </div>

        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '4px', marginBottom: '12px' }}>
          {product.effects.slice(0, 2).map((effect, index) => (
            <span
              key={effect}
              style={{
                fontSize: '10px',
                padding: '2px 6px',
                backgroundColor: index % 2 === 0 ? 'rgba(139, 92, 246, 0.2)' : 'rgba(245, 158, 11, 0.2)',
                color: index % 2 === 0 ? '#8b5cf6' : '#f59e0b',
                borderRadius: '6px',
                fontWeight: '500'
              }}
            >
              {effect}
            </span>
          ))}
        </div>

        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <span style={{ fontSize: '18px', fontWeight: '700', color: '#00d4aa' }}>
              {product.price}
            </span>
            
            {/* Pricing indicator badge */}
            {product.pricing?.has_pricing ? (
              <span style={{
                fontSize: '10px',
                padding: '2px 6px',
                background: 'rgba(0, 212, 170, 0.2)',
                color: '#00d4aa',
                borderRadius: '4px',
                fontWeight: '600'
              }}>
                AVG
              </span>
            ) : (
              <span style={{
                fontSize: '10px',
                padding: '2px 6px',
                background: 'rgba(139, 92, 246, 0.2)',
                color: '#8b5cf6',
                borderRadius: '4px',
                fontWeight: '600'
              }}>
                EST
              </span>
            )}
          </div>
          
          <div style={{
            padding: '4px 8px',
            background: `linear-gradient(135deg, ${product.engagement > 90 ? '#00d4aa' : product.engagement > 80 ? '#f59e0b' : '#666'} 0%, ${product.engagement > 90 ? '#10b981' : product.engagement > 80 ? '#d97706' : '#555'} 100%)`,
            color: product.engagement > 90 ? '#0a0a0a' : 'white',
            borderRadius: '8px',
            fontSize: '10px',
            fontWeight: '600'
          }}>
            {product.engagement}% match
          </div>
        </div>

        {product.deals.length > 0 && (
          <div style={{
            marginTop: '8px',
            padding: '6px 8px',
            background: 'linear-gradient(135deg, rgba(245, 158, 11, 0.2) 0%, rgba(217, 119, 6, 0.2) 100%)',
            color: '#f59e0b',
            borderRadius: '6px',
            fontSize: '11px',
            fontWeight: '500',
            display: 'flex',
            alignItems: 'center',
            gap: '4px'
          }}>
            <Zap size={10} />
            {product.deals[0]}
          </div>
        )}
      </div>
    </div>
  );
};

const FilterSidebar = ({ activeFilters, onFilterChange, sortBy, onSortChange, isOpen, onClose, colors , strainType, // Add this
  onStrainTypeChange  }) => {
  const handleCategoryChange = (category, checked) => {
    const newCategories = checked 
      ? [...activeFilters.category, category]
      : activeFilters.category.filter(c => c !== category);
    
    onFilterChange({
      ...activeFilters,
      category: newCategories
    });
  };

  const handleEffectChange = (effect, checked) => {
    const newEffects = checked 
      ? [...activeFilters.effects, effect]
      : activeFilters.effects.filter(e => e !== effect);
    
    onFilterChange({
      ...activeFilters,
      effects: newEffects
    });
  };

  const handlePriceChange = (field, value) => {
    onFilterChange({
      ...activeFilters,
      [field]: value
    });
  };

  return (
    <>
      {/* Mobile Overlay */}
      <div 
        style={{
          position: 'fixed',
          inset: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          zIndex: 40,
          display: isOpen ? 'block' : 'none',
          '@media (min-width: 768px)': {
            display: 'none'
          }
        }}
        onClick={onClose}
      />
      
      <div style={{
        background: colors.comeCard,
        border: '1px solid #333',
        borderRadius: '16px',
        overflow: 'hidden',
        // Mobile-specific styles
        position: window.innerWidth < 768 ? 'fixed' : 'static',
        top: window.innerWidth < 768 ? 0 : 'auto',
        left: window.innerWidth < 768 ? 0 : 'auto',
        right: window.innerWidth < 768 ? 0 : 'auto',
        bottom: window.innerWidth < 768 ? 0 : 'auto',
        zIndex: window.innerWidth < 768 ? 50 : 'auto',
        transform: window.innerWidth < 768 ? (isOpen ? 'translateX(0)' : 'translateX(-100%)') : 'none',
        transition: window.innerWidth < 768 ? 'transform 0.3s ease' : 'none',
        maxWidth: window.innerWidth < 768 ? '280px' : 'none',
        height: window.innerWidth < 768 ? '100vh' : 'auto',
        overflowY: window.innerWidth < 768 ? 'auto' : 'visible'
      }}>
        <div style={{
          padding: '20px',
          borderBottom: `1px solid ${colors.border}`,
          background: colors.filterInactiveBackground,
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}>
          <h3 style={{
            fontWeight: '600',
            margin: 0,
            color: '#e5e5e5',
            display: 'flex',
            alignItems: 'center',
            gap: '8px'
          }}>
            <Filter size={18} style={{ color: '#00d4aa' }} />
            Filters
          </h3>
          {/* Mobile close button */}
          {window.innerWidth < 768 && (
            <button
              onClick={onClose}
              style={{
                background: 'none',
                border: 'none',
                color: '#888',
                cursor: 'pointer',
                padding: '4px'
              }}
            >
              <X size={20} />
            </button>
          )}
        </div>

        <div style={{ padding: '20px', display: 'flex', flexDirection: 'column', gap: '24px' }}>
          {/* Category Filter */}
          <div>
            <label style={{
              fontSize: '16px',
              fontWeight: '600',
              display: 'block',
              marginBottom: '12px',
              color: '#e5e5e5'
            }}>
              Category
            </label>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
            {['flower', 'cart', 'edible', 'pre-roll', 'concentrate'].map((category) => {
              const displayNames = {
                'flower': 'Flower',
                'cart': 'Vapes',
                'edible': 'Edibles',
                'pre-roll': 'Pre-rolls',
                'concentrate': 'Concentrates'
              };
              
              return (
                <label key={category} style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  cursor: 'pointer',
                  padding: '8px',
                  borderRadius: '8px',
                  transition: 'background-color 0.2s ease'
                }}
                onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#2a2a2a'}
                onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
                >
                  <input
                    type="checkbox"
                    checked={activeFilters.category.includes(category)}
                    onChange={(e) => handleCategoryChange(category, e.target.checked)}
                    style={{
                      accentColor: '#00d4aa',
                      transform: 'scale(1.2)'
                    }}
                  />
                  <span style={{ color: '#b3b3b3' }}>{displayNames[category]}</span>
                </label>
              );
            })}
          </div>
          </div>

          <div>
            <label style={{
              fontSize: '16px',
              fontWeight: '600',
              display: 'block',
              marginBottom: '12px',
              color: '#e5e5e5'
            }}>
              Strain Type
            </label>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
              {['Indica', 'Hybrid', 'Sativa'].map((type) => (
                <label key={type} style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  cursor: 'pointer',
                  padding: '8px',
                  borderRadius: '8px',
                  transition: 'background-color 0.2s ease'
                }}
                onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#2a2a2a'}
                onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
                >
                  <input
                    type="radio"
                    name="strainType"
                    checked={activeFilters.strainType === type}
                    onChange={() => {
                      // Update both activeFilters and the separate strainType state
                      onFilterChange({
                        ...activeFilters,
                        strainType: activeFilters.strainType === type ? null : type
                      });
                    }}
                    style={{
                      accentColor: '#00d4aa',
                      transform: 'scale(1.2)'
                    }}
                  />
                  <span style={{ color: '#b3b3b3' }}>{type}</span>
                </label>
              ))}
            </div>
          </div>
          {/* Effects Filter */}
          <div>
            <label style={{
              fontSize: '16px',
              fontWeight: '600',
              display: 'block',
              marginBottom: '12px',
              color: '#e5e5e5'
            }}>
              Effects
            </label>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
              {['Relaxing', 'Energizing', 'Creative', 'Focus', 'Sleep'].map((effect) => (
                <label key={effect} style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  cursor: 'pointer',
                  padding: '8px',
                  borderRadius: '8px',
                  transition: 'background-color 0.2s ease'
                }}
                onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#2a2a2a'}
                onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
                >
                  <input
                    type="checkbox"
                    checked={activeFilters.effects.includes(effect)}
                    onChange={(e) => handleEffectChange(effect, e.target.checked)}
                    style={{
                      accentColor: '#00d4aa',
                      transform: 'scale(1.2)'
                    }}
                  />
                  <span style={{ color: '#b3b3b3' }}>{effect}</span>
                </label>
              ))}
            </div>
          </div>

          {/* Sort Options */}
          <div>
            <label style={{
              fontSize: '16px',
              fontWeight: '600',
              display: 'block',
              marginBottom: '12px',
              color: '#e5e5e5'
            }}>
              Sort By
            </label>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
              {[
                { value: 'rating', label: '⭐ Top Rated' },
                { value: 'newest', label: '🆕 Newest' },
                { value: 'price-low', label: '💰 Price: Low to High' },
                { value: 'distance', label: '📍 Nearest' }
              ].map((option) => (
                <label key={option.value} style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px',
                    cursor: 'pointer',
                    padding: '8px',
                    borderRadius: '8px',
                    transition: 'background-color 0.2s ease'
                  }}
                  onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#2a2a2a'}
                  onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
                  >
                  <input
                    type="radio"
                    name="sort"
                    value={option.value}
                    checked={sortBy === option.value}
                    onChange={(e) => onSortChange(e.target.value)}
                    style={{
                      accentColor: '#00d4aa',
                      transform: 'scale(1.2)'
                    }}
                  />
                  <span style={{ color: '#b3b3b3' }}>{option.label}</span>
                </label>
              ))}
            </div>
          </div>

          {/* Price Range */}
          <div>
            <label style={{
              fontSize: '16px',
              fontWeight: '600',
              display: 'block',
              marginBottom: '12px',
              color: '#e5e5e5'
            }}>
              Price Range
            </label>
            <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
              <input
                type="number"
                placeholder="Min"
                value={activeFilters.priceMin}
                onChange={(e) => handlePriceChange('priceMin', e.target.value)}
                style={{
                  flex: 1,
                  padding: '8px',
                  backgroundColor: '#2a2a2a',
                  border: '1px solid #333',
                  borderRadius: '8px',
                  color: '#e5e5e5',
                  fontSize: '14px'
                }}
              />
              <span style={{ color: '#888' }}>-</span>
              <input
                type="number"
                placeholder="Max"
                value={activeFilters.priceMax}
                onChange={(e) => handlePriceChange('priceMax', e.target.value)}
                style={{
                  flex: 1,
                  padding: '8px',
                  backgroundColor: '#2a2a2a',
                  border: '1px solid #333',
                  borderRadius: '8px',
                  color: '#e5e5e5',
                  fontSize: '14px'
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const DealsAlert = () => {
  return (
    <div style={{
      background: 'linear-gradient(135deg, #1a2e2e 0%, #0f2027 100%)',
      border: '1px solid #2d4a4a',
      borderRadius: '16px',
      marginTop: '24px',
      overflow: 'hidden'
    }}>
      <div style={{
        padding: '20px',
        borderBottom: '1px solid #2d4a4a'
      }}>
        <h3 style={{
          fontWeight: '600',
          margin: 0,
          color: '#00d4aa',
          display: 'flex',
          alignItems: 'center',
          gap: '8px'
        }}>
          <Zap size={18} />
          Live Deals
        </h3>
      </div>
      <div style={{ padding: '16px' }}>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
          {dealsSidebar.map((deal, index) => (
            <div
              key={index}
              style={{
                padding: '12px',
                background: 'rgba(0, 212, 170, 0.1)',
                borderRadius: '8px',
                border: '1px solid #00d4aa'
              }}
            >
              <div style={{ fontWeight: '600', color: '#00d4aa', fontSize: '14px', marginBottom: '4px' }}>
                {deal.dispensary}
              </div>
              <div style={{ color: '#e5e5e5', fontSize: '12px', marginBottom: '4px' }}>
                {deal.deal}
              </div>
              <div style={{ color: '#888', fontSize: '10px' }}>
                Expires: {deal.expires}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export function ProductsPage() {
  const location = useLocation();

  const [activeFilters, setActiveFilters] = useState(() => {
    const params = new URLSearchParams(location.search);
    const categoryParam = params.get('category');
    
    return {
      category: categoryParam ? [categoryParam] : [],
      effects: [],
      priceMin: '',
      priceMax: '',
      strainType: null
    };
  });
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { colors } = useTheme();
  const [searchInput, setSearchInput] = useState(''); // What user types
  const [searchTerm, setSearchTerm] = useState('');
  const [strainType, setStrainType] = useState(null); // ✅ ADD THIS NEW STATE

  const [isStrainTypeExpanded, setIsStrainTypeExpanded] = useState(false);


  const [sortBy, setSortBy] = useState('rating');
  const [viewMode, setViewMode] = useState('grid');
  const [isFilterOpen, setIsFilterOpen] = useState(false);

  const [isDispensaryModalOpen, setIsDispensaryModalOpen] = useState(false);
  const { user, isAuthenticated, logout, refreshUserStats } = useUser();
  
  const [isFindNearbyModalOpen, setIsFindNearbyModalOpen] = useState(false);
  const [selectedDispensary, setSelectedDispensary] = useState(null);

  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalProducts, setTotalProducts] = useState(0);
  const [perPage, setPerPage] = useState(20);
  const [hasNext, setHasNext] = useState(false);
  const [hasPrev, setHasPrev] = useState(false);

  // Mobile detection
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const categoryParam = params.get('category');
    const strainTypeParam = params.get('strain_type');
    
    if (categoryParam) {
      setActiveFilters(prev => ({
        ...prev,
        category: [categoryParam]
      }));
    }
    
    // Sync both states
    if (strainTypeParam) {
      setStrainType(strainTypeParam);
      setActiveFilters(prev => ({
        ...prev,
        strainType: strainTypeParam
      }));
    } else {
      setStrainType(null);
      setActiveFilters(prev => ({
        ...prev,
        strainType: null
      }));
    }
  }, [location.search]);

  let url;
  if (!isAuthenticated){
    url = getSmokerEmoji('stoner');
  }else{
    url = getSmokerEmoji(user.smoker_level);
  }

  const handleTrendingSearch = (searchTerm) => {
    setSearchTerm(searchTerm);
  };

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isSubmittingProduct, setIsSubmittingProduct] = useState(false);

  const [loadingMore, setLoadingMore] = useState(false);

  const [pagination, setPagination] = useState({
    current_page: 1,
    total_pages: 1,
    total_products: 0,
    has_next: false,
    has_prev: false
  });

   useEffect(() => {
      loadProducts();
  }, [currentPage, perPage, activeFilters, sortBy, searchTerm, strainType]); // ✅ ADD strainType

  const handleLoadMore = () => {
    if (pagination.has_next && !loadingMore) {
      loadProducts(pagination.current_page + 1, false);
    }
  };

  const navigate = useNavigate();


  const handleDispensarySubmission = async (dispensaryData) => {
    try {
      const response = await fetch(`${API_URL}/api/submit-dispensary`, {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(dispensaryData)
      });

      if (!response.ok) {
        throw new Error('Failed to submit dispensary');
      }

      const result = await response.json();
      if (result.success) {
        alert('🎉 Dispensary submitted successfully! It will be reviewed and published soon.');
      } else {
        throw new Error(result.error || 'Unknown error');
      }
    } catch (error) {
      console.error('Error submitting dispensary:', error);
      throw error;
    }
  };

  const handleSearchInputChange = (e) => {
    setSearchInput(e.target.value);
  };

  const handleSearchSubmit = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      setSearchTerm(searchInput.trim());
      setCurrentPage(1); // Reset to first page for new search
    }
  };

  // Handle search button click (optional)
  const handleSearchButtonClick = () => {
    setSearchTerm(searchInput.trim());
    setCurrentPage(1);
  };

  const clearSearch = () => {
    setSearchInput('');
    setSearchTerm('');
    setCurrentPage(1);
  };

  const loadProducts = async () => {
    try {
      setLoading(true);
      
      const response = await ApiService.getAllProductsPagination(
        currentPage,
        perPage,
        sortBy,
        activeFilters.category.length > 0 ? activeFilters.category.join(',') : null,
        activeFilters.effects.length > 0 ? activeFilters.effects.join(',') : null,
        activeFilters.priceMin || null,
        activeFilters.priceMax || null,
        searchTerm || null,
        strainType || null // Add search term here
      );
            
      const transformedProducts = response.products.map(product => ({
        id: product.id,
        name: product.name,
        slug: product.name.toLowerCase().replace(/\s+/g, '-'),
        brand: product.brand,
        category: mapProductType(product.type),
        thc: extractTHC(product.attributes),
        price: generatePrice(product), // Now uses the product object with pricing data
        rating: product.avg_rating ? parseFloat(product.avg_rating.toFixed(1)) : 0,
        reviewCount: product.review_count || 0,
        image: product.cover_image || 
          (product.coverImage?.imageUrl) || 
          (product.images?.length > 0 ? product.images[0].imageUrl : null) ||
          getProductImage(product.type),
        trending: (product.review_count || 0) > 10,
        hot: (product.avg_rating || 0) > 8.5,
        newArrival: false,
        effects: getEffects(product.attributes),
        terpenes: getTerpenes(product.attributes),
        inStock: true,
        dispensaryDistance: "0.8 miles",
        featured: (product.avg_rating || 0) > 8.5,
        deals: [],
        wishlistCount: Math.floor(Math.random() * 100),
        engagement: Math.floor(((product.avg_rating || 0) * 10) + Math.min((product.review_count || 0), 20)),
        
        // Add pricing object to the frontend product for consistent access
        pricing: product.pricing || {
          has_pricing: false,
          average_price: null,
          min_price: null,
          max_price: null,
          location_count: 0
        }
      }));

      setProducts(transformedProducts);
      
      if (response.pagination) {
        setTotalPages(response.pagination.total_pages);
        setTotalProducts(response.pagination.total_products);
        setHasNext(response.pagination.has_next);
        setHasPrev(response.pagination.has_prev);
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleProductSubmission = async (productData) => {
    setIsSubmittingProduct(true);
    try {
      const response = await fetch(`${API_URL}/api/submit-product-review`, {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(productData)
      });

      if (!response.ok) {
        throw new Error('Failed to submit product');
      }

      const result = await response.json();
      if (result.success) {
        alert('🎉 Product submitted successfully! It will be reviewed and published soon.');
      } else {
        throw new Error(result.error || 'Unknown error');
      }
    } catch (error) {
      console.error('Error submitting product:', error);
      throw error;
    } finally {
      setIsSubmittingProduct(false);
    }
  };

  const extractTHC = (attributes) => {
    try {
      const attrs = typeof attributes === 'string' ? JSON.parse(attributes) : attributes;
      return parseFloat((attrs.THC || '0').replace('%', '')) || 0;
    } catch { return 0; }
  };

  const mapProductType = (type) => {
    const map = { 'flower': 'Flower', 'cart': 'Vapes', 'edible': 'Edibles', 'pre-roll': 'Pre-rolls', 'concentrate': 'Concentrates' };
    return map[type] || 'Other';
  };

 const generatePrice = (product) => {
    // Check if product has real pricing data from dispensaries
    if (product.pricing && product.pricing.has_pricing && product.pricing.average_price) {
      return `$${product.pricing.average_price}`;
    }
    
    // Fallback to mock prices if no real pricing available
    const basePrices = { 'flower': 35, 'cart': 65, 'edible': 25, 'pre-roll': 15 };
    return `$${basePrices[product.type] || 30}`;
  };

  const getEffects = (attributes) => {
    try {
      const attrs = typeof attributes === 'string' ? JSON.parse(attributes) : attributes;
      
      const terpeneDatabase = {
        "myrcene": { effects: ["Relaxing", "Sleep"], description: "Relaxing, sedating effects" },
        "limonene": { effects: ["Energizing", "Creative"], description: "Mood elevation, stress relief" },
        "caryophyllene": { effects: ["Focus", "Relaxing"], description: "Anti-inflammatory properties" },
        "pinene": { effects: ["Focus", "Energizing"], description: "Alertness, memory retention" },
        "terpinolene": { effects: ["Energizing", "Creative"], description: "Uplifting, energizing effects" },
        "linalool": { effects: ["Relaxing", "Sleep"], description: "Calming, anti-anxiety" },
        "humulene": { effects: ["Focus"], description: "Anti-inflammatory, appetite suppressant" },
        "ocimene": { effects: ["Energizing"], description: "Uplifting, decongestant" },
        "terpineol": { effects: ["Relaxing"], description: "Relaxing, antibiotic properties" },
        "valencene": { effects: ["Focus"], description: "Anti-inflammatory, insect repellent" }
      };

      if (attrs.terpenes && Array.isArray(attrs.terpenes)) {
        const terpeneEffects = [];
        attrs.terpenes.forEach(terpene => {
          if (terpeneDatabase[terpene.toLowerCase()]) {
            terpeneEffects.push(...terpeneDatabase[terpene.toLowerCase()].effects);
          }
        });
        
        const uniqueEffects = [...new Set(terpeneEffects)];
        if (uniqueEffects.length > 0) {
          return uniqueEffects;
        }
      }

      const effectsMap = {
        'Sativa': ['Energizing', 'Creative'],
        'Indica': ['Relaxing', 'Sleep'],
        'Hybrid': ['Focus', 'Creative']
      };
      
      return effectsMap[attrs.strain_type] || ['Relaxing', 'Focus'];
    } catch { 
      return ['Relaxing', 'Focus']; 
    }
  };

  const CategoryIcons = {
    flower: () => <img src="/branding/menu/flower.svg" alt="Flower" style={{ width: '2rem', height: '2rem', filter: 'brightness(0) invert(1)' }} />,
    cart: () => <img src="/branding/menu/cart.svg" alt="Cartridge/Vape" style={{ width: '2rem', height: '2rem', filter: 'brightness(0) invert(1)' }} />,
    edible: () => <img src="/branding/menu/edibble.svg" alt="Edible" style={{ width: '2rem', height: '2rem', filter: 'brightness(0) invert(1)' }} />,
    'pre-roll': () => <img src="/branding/menu/prerol.svg" alt="Pre-roll" style={{ width: '2rem', height: '2rem', filter: 'brightness(0) invert(1)' }} />,
    concentrate: () => <img src="/branding/menu/_con.svg" alt="Concentrate" style={{ width: '2rem', height: '2rem', filter: 'brightness(0) invert(1)' }} />,
    other: () => <img src="/branding/menu/Frame.svg" alt="Other" style={{ width: '2rem', height: '2rem', filter: 'brightness(0) invert(1)' }} />
  };

  const handleDispensarySelect = (dispensary) => {
    setSelectedDispensary(dispensary);
    console.log('Selected dispensary:', dispensary);
  };

  const getTerpenes = (attributes) => {
    try {
      const attrs = typeof attributes === 'string' ? JSON.parse(attributes) : attributes;
      return attrs.terpenes || ['Myrcene', 'Limonene', 'Caryophyllene'];
    } catch { return ['Myrcene', 'Limonene', 'Caryophyllene']; }
  };

  if (loading) {
    return (
      <div style={{
        minHeight: '100vh',
        backgroundColor: '#0a0a0a',
        color: 'white',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}>
        <div style={{ textAlign: 'center' }}>
          <div style={{ 
            fontSize: '48px',
            marginBottom: '16px',
            animation: 'spin 1s linear infinite'
          }}>🌿</div>
          <p style={{ color: '#888' }}>Loading Products...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div style={{ minHeight: '100vh', backgroundColor: '#0a0a0a', color: 'white', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        Error: {error}
      </div>
    );
  }

  const filteredProducts = products.filter(product =>
    product.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    product.brand.toLowerCase().includes(searchTerm.toLowerCase()) ||
    product.effects.some(effect => effect.toLowerCase().includes(searchTerm.toLowerCase()))
  );

  const handleWishlist = (productId) => {
    console.log('Added to wishlist:', productId);
  };

  const handleQuickView = (productId) => {
    console.log('Quick view:', productId);
  };

  return (
    <div style={{
      minHeight: '100vh',
      backgroundColor: '#0a0a0a',
      color: 'white',
      fontFamily: 'system-ui, -apple-system, sans-serif'
    }}>
      <style>{`
        @keyframes pulse {
          0%, 100% { opacity: 1; }
          50% { opacity: 0.8; }
        }
        
        @keyframes slideUp {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        
        .slide-up {
          animation: slideUp 0.6s ease-out;
        }

        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }

        /* Mobile-specific styles */
        @media (max-width: 767px) {
          .mobile-header-buttons {
            flex-direction: column;
            gap: 8px;
            width: 100%;
          }
          
          .mobile-header-buttons button {
            width: 100%;
            justify-content: center;
          }
          
          .mobile-quick-filters {
            flex-wrap: wrap;
            gap: 6px;
          }
          
          .mobile-quick-filters button {
            flex: 1 1 auto;
            min-width: 120px;
            font-size: 11px;
            padding: 6px 12px;
          }
          
          .mobile-results-header {
            flex-direction: column;
            gap: 16px;
            align-items: flex-start;
          }
          
          .mobile-pagination-controls {
            flex-direction: column;
            gap: 12px;
          }
          
          .mobile-page-numbers {
            flex-wrap: wrap;
            justify-content: center;
          }
        }
      `}</style>

      <div style={{ maxWidth: '1400px', margin: '0 auto', padding: isMobile ? '16px' : '32px 24px' }}>
        {/* Header Section */}
        <div style={{ marginBottom: isMobile ? '24px' : '32px' }}>
          <div style={{ 
            display: 'flex', 
            alignItems: isMobile ? 'flex-start' : 'center', 
            justifyContent: 'space-between', 
            marginBottom: '24px',
            flexDirection: isMobile ? 'column' : 'row',
            gap: isMobile ? '20px' : '0'
          }}>
            <div>
              <h1 style={{
                fontSize: isMobile ? '24px' : '32px',
                fontWeight: '800',
                margin: '0 0 8px 0',
                background: 'linear-gradient(135deg, #00d4aa 0%, #10b981 100%)',
                backgroundClip: 'text',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent'
              }}>
                Cannabis Products
              </h1>
              <p style={{ margin: 0, color: '#888', fontSize: isMobile ? '14px' : '16px' }}>
                Discover the best products from dispensaries near you 🌿
              </p>
            </div>
            
            <div className="mobile-header-buttons" style={{ 
              display: 'flex', 
              alignItems: 'center', 
              gap: '12px',
              flexDirection: isMobile ? 'column' : 'row',
              width: isMobile ? '100%' : 'auto'
            }}>
              <button 
                onClick={() => navigate('/thc-leaderboard')}
                style={{
                  padding: isMobile ? '10px 16px' : '12px 20px',
                  background: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)',
                  color: '#0a0a0a',
                  border: 'none',
                  borderRadius: '12px',
                  fontWeight: '600',
                  cursor: 'pointer',
                  transition: 'all 0.3s ease',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  fontSize: isMobile ? '14px' : '16px'
                }}
              >
                <Target size={16} />
                THC Leaderboard
              </button>
              <button 
                onClick={() => setIsDispensaryModalOpen(true)}
                style={{
                  padding: isMobile ? '10px 16px' : '12px 20px',
                  background: 'linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%)',
                  color: 'white',
                  border: 'none',
                  borderRadius: '12px',
                  fontWeight: '600',
                  cursor: 'pointer',
                  transition: 'all 0.3s ease',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  fontSize: isMobile ? '14px' : '16px',
                  width: isMobile ? '100%' : 'auto',
                  justifyContent: isMobile ? 'center' : 'flex-start'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-2px)';
                  e.currentTarget.style.boxShadow = '0 8px 20px rgba(139, 92, 246, 0.4)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = 'none';
                }}
              >
                <MapPin size={16} />
                Add Dispensary
              </button>

              <button 
                onClick={() => setIsModalOpen(true)}
                disabled={isSubmittingProduct}
                style={{
                  padding: isMobile ? '10px 16px' : '12px 20px',
                  background: isSubmittingProduct 
                    ? '#666' 
                    : 'linear-gradient(135deg, #00d4aa 0%, #10b981 100%)',
                  color: isSubmittingProduct ? '#ccc' : '#0a0a0a',
                  border: 'none',
                  borderRadius: '12px',
                  fontWeight: '600',
                  cursor: isSubmittingProduct ? 'not-allowed' : 'pointer',
                  transition: 'all 0.3s ease',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  opacity: isSubmittingProduct ? 0.7 : 1,
                  fontSize: isMobile ? '14px' : '16px',
                  width: isMobile ? '100%' : 'auto',
                  justifyContent: isMobile ? 'center' : 'flex-start'
                }}
                onMouseEnter={(e) => {
                  if (!isSubmittingProduct) {
                    e.currentTarget.style.transform = 'translateY(-2px)';
                    e.currentTarget.style.boxShadow = '0 8px 20px rgba(0, 212, 170, 0.4)';
                  }
                }}
                onMouseLeave={(e) => {
                  if (!isSubmittingProduct) {
                    e.currentTarget.style.transform = 'translateY(0)';
                    e.currentTarget.style.boxShadow = 'none';
                  }
                }}
              >
                {isSubmittingProduct ? (
                  <>
                    <div style={{
                      width: '16px',
                      height: '16px',
                      border: '2px solid #ccc',
                      borderTop: '2px solid transparent',
                      borderRadius: '50%',
                      animation: 'spin 1s linear infinite'
                    }} />
                    Submitting...
                  </>
                ) : (
                  <>
                    <Award size={16} />
                    {isMobile ? 'Submit' : 'Submit Review/Product'}
                  </>
                )}
              </button>
              
              <button 
                onClick={() => setIsFindNearbyModalOpen(true)}
                style={{
                  padding: isMobile ? '10px 16px' : '12px 20px',
                  background: 'linear-gradient(135deg, #00d4aa 0%, #10b981 100%)',
                  color: '#0a0a0a',
                  border: 'none',
                  borderRadius: '12px',
                  fontWeight: '600',
                  cursor: 'pointer',
                  transition: 'all 0.3s ease',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  fontSize: isMobile ? '14px' : '16px',
                  width: isMobile ? '100%' : 'auto',
                  justifyContent: isMobile ? 'center' : 'flex-start'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-2px)';
                  e.currentTarget.style.boxShadow = '0 8px 20px rgba(0, 212, 170, 0.4)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = 'none';
                }}
              >
                <MapPin size={16} />
                Find Nearby
              </button>
            </div>
          </div>

          {/* Search Bar */}
          <div style={{
            background: colors.comeCard,
            border: '1px solid #333',
            borderRadius: '16px',
            padding: isMobile ? '16px' : '24px'
          }}>
            <div style={{ position: 'relative', marginBottom: '16px' }}>
              <Search size={isMobile ? 18 : 20} style={{
                position: 'absolute',
                left: isMobile ? '12px' : '16px',
                top: '50%',
                transform: 'translateY(-50%)',
                color: '#888'
              }} />
              
              <input
                type="text"
                placeholder="Search strains, brands, effects... (Press Enter to search)"
                value={searchInput} // Uses searchInput state
                onChange={handleSearchInputChange} // Only updates input state
                onKeyDown={handleSearchSubmit} // Triggers search on Enter
                style={{
                  width: '100%',
                  paddingLeft: isMobile ? '40px' : '48px',
                  paddingRight: isMobile ? '80px' : '120px', // Space for buttons
                  paddingTop: isMobile ? '12px' : '16px',
                  paddingBottom: isMobile ? '12px' : '16px',
                  border: '2px solid #333',
                  borderRadius: '12px',
                  fontSize: isMobile ? '14px' : '16px',
                  outline: 'none',
                  transition: 'all 0.3s ease',
                  boxSizing: 'border-box',
                  backgroundColor: '#1A1A1A',
                  color: '#e5e5e5'
                }}
                onFocus={(e) => {
                  e.currentTarget.style.borderColor = '#00d4aa';
                  e.currentTarget.style.boxShadow = '0 0 0 4px rgba(0, 212, 170, 0.1)';
                }}
                onBlur={(e) => {
                  e.currentTarget.style.borderColor = '#333';
                  e.currentTarget.style.boxShadow = 'none';
                }}
              />

              {/* Search and Clear buttons */}
              <div style={{
                position: 'absolute',
                right: isMobile ? '8px' : '12px',
                top: '50%',
                transform: 'translateY(-50%)',
                display: 'flex',
                gap: '4px'
              }}>
                {/* Search button */}
                <button
                  onClick={handleSearchButtonClick}
                  style={{
                    padding: '6px 12px',
                    background: 'linear-gradient(135deg, #00d4aa 0%, #10b981 100%)',
                    color: '#0a0a0a',
                    border: 'none',
                    borderRadius: '6px',
                    fontSize: isMobile ? '11px' : '12px',
                    fontWeight: '600',
                    cursor: 'pointer',
                    transition: 'all 0.2s ease'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'scale(1.05)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'scale(1)';
                  }}
                >
                  Search
                </button>

                {/* Clear button - only show if there's search input or active search */}
                {(searchInput || searchTerm) && (
                  <button
                    onClick={clearSearch}
                    style={{
                      padding: '6px 8px',
                      background: '#333',
                      color: '#888',
                      border: 'none',
                      borderRadius: '6px',
                      fontSize: isMobile ? '11px' : '12px',
                      cursor: 'pointer',
                      transition: 'all 0.2s ease'
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.background = '#444';
                      e.currentTarget.style.color = '#ccc';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.background = '#333';
                      e.currentTarget.style.color = '#888';
                    }}
                  >
                    ✕
                  </button>
                )}
              </div>
            </div>

            {/* Show current search term if different from input */}
            {searchTerm && searchTerm !== searchInput && (
              <div style={{
                padding: '8px 12px',
                background: 'rgba(0, 212, 170, 0.1)',
                border: '1px solid #00d4aa',
                borderRadius: '8px',
                fontSize: '12px',
                color: '#00d4aa',
                marginBottom: '16px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between'
              }}>
                <span>Searching for: "{searchTerm}"</span>
                <button
                  onClick={clearSearch}
                  style={{
                    background: 'none',
                    border: 'none',
                    color: '#00d4aa',
                    cursor: 'pointer',
                    fontWeight: 'bold'
                  }}
                >
                  ✕
                </button>
              </div>
            )}
              
            <div style={{
              background: colors.comeCard,
              border: '1px solid #333',
              borderRadius: '12px',
              padding: isMobile ? '12px' : '16px',
              marginBottom: '16px'
            }}>
              <h4 style={{
                margin: '0 0 12px 0',
                fontSize: isMobile ? '14px' : '16px',
                fontWeight: '600',
                color: '#e5e5e5'
              }}>
                Select Categories
              </h4>
              
              <div style={{
                display: 'flex',
                gap: isMobile ? '8px' : '12px',
                alignItems: 'center',
                overflowX: 'auto',
                paddingBottom: '4px'
              }}>
                {/* All Categories Option */}
                <div
                  onClick={() => setActiveFilters(prev => ({ ...prev, category: [] }))}
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    padding: isMobile ? '8px 12px' : '12px 16px',
                    borderRadius: '12px',
                    cursor: 'pointer',
                    backgroundColor: activeFilters.category.length === 0 ? 'rgba(0, 212, 170, 0.2)' : 'rgba(255, 255, 255, 0.05)',
                    border: activeFilters.category.length === 0 ? '2px solid #00d4aa' : '2px solid transparent',
                    transition: 'all 0.2s ease',
                    minWidth: 'fit-content',
                    whiteSpace: 'nowrap'
                  }}
                  onMouseEnter={(e) => {
                    if (activeFilters.category.length !== 0) {
                      e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.1)';
                    }
                  }}
                  onMouseLeave={(e) => {
                    if (activeFilters.category.length !== 0) {
                      e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.05)';
                    }
                  }}
                >
                  <Package size={isMobile ? 20 : 24} style={{ 
                    color: activeFilters.category.length === 0 ? '#00d4aa' : '#888',
                    marginBottom: '6px'
                  }} />
                  <span style={{
                    fontSize: isMobile ? '10px' : '12px',
                    fontWeight: '600',
                    color: activeFilters.category.length === 0 ? '#00d4aa' : '#e5e5e5'
                  }}>
                    All
                  </span>
                </div>

                {/* Category Options */}
                {Object.keys(CategoryIcons).map((category) => {
                  const isSelected = activeFilters.category.includes(category);
                  const IconComponent = CategoryIcons[category];
                  const displayName = category === 'cart' ? 'Vapes' : 
                                    category === 'pre-roll' ? 'Pre-rolls' : 
                                    category.charAt(0).toUpperCase() + category.slice(1);
                  
                  return (
                    <div
                      key={category}
                      onClick={() => {
                        setActiveFilters(prev => ({
                          ...prev,
                          category: isSelected 
                            ? prev.category.filter(c => c !== category)
                            : [...prev.category, category]
                        }));
                      }}
                      style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        padding: isMobile ? '8px 12px' : '12px 16px',
                        borderRadius: '12px',
                        cursor: 'pointer',
                        backgroundColor: isSelected ? 'rgba(0, 212, 170, 0.2)' : 'rgba(255, 255, 255, 0.05)',
                        border: isSelected ? '2px solid #00d4aa' : '2px solid transparent',
                        transition: 'all 0.2s ease',
                        minWidth: 'fit-content',
                        whiteSpace: 'nowrap',
                        position: 'relative'
                      }}
                      onMouseEnter={(e) => {
                        if (!isSelected) {
                          e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.1)';
                        }
                      }}
                      onMouseLeave={(e) => {
                        if (!isSelected) {
                          e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.05)';
                        }
                      }}
                    >
                      <div style={{
                        marginBottom: '6px',
                        color: isSelected ? '#00d4aa' : '#888',
                        transform: isMobile ? 'scale(0.8)' : 'scale(1)'
                      }}>
                        <IconComponent />
                      </div>
                      <span style={{
                        fontSize: isMobile ? '10px' : '12px',
                        fontWeight: '600',
                        color: isSelected ? '#00d4aa' : '#e5e5e5'
                      }}>
                        {displayName}
                      </span>
                      
                      {/* Selection indicator */}
                      {isSelected && (
                        <div style={{
                          position: 'absolute',
                          top: '4px',
                          right: '4px',
                          width: '12px',
                          height: '12px',
                          borderRadius: '50%',
                          background: 'linear-gradient(135deg, #00d4aa 0%, #10b981 100%)',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center'
                        }}>
                          <span style={{ color: '#0a0a0a', fontSize: '8px', fontWeight: '600' }}>✓</span>
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
              
              {/* Selected Categories Display */}
              {activeFilters.category.length > 0 && (
                <div style={{
                  marginTop: '12px',
                  display: 'flex',
                  flexWrap: 'wrap',
                  gap: '6px'
                }}>
                  <span style={{ fontSize: '12px', color: '#888', marginRight: '8px' }}>Selected:</span>
                  {activeFilters.category.map(category => (
                    <span
                      key={category}
                      style={{
                        background: 'linear-gradient(135deg, rgba(0, 212, 170, 0.2) 0%, rgba(16, 185, 129, 0.2) 100%)',
                        color: '#00d4aa',
                        padding: '2px 8px',
                        borderRadius: '8px',
                        fontSize: '10px',
                        fontWeight: '600',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '4px'
                      }}
                    >
                      {category === 'cart' ? 'Vapes' : 
                      category === 'pre-roll' ? 'Pre-rolls' : 
                      category.charAt(0).toUpperCase() + category.slice(1)}
                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          setActiveFilters(prev => ({
                            ...prev,
                            category: prev.category.filter(c => c !== category)
                          }));
                        }}
                        style={{
                          background: 'none',
                          border: 'none',
                          color: '#00d4aa',
                          cursor: 'pointer',
                          padding: '0',
                          fontSize: '12px',
                          fontWeight: 'bold'
                        }}
                      >
                        ×
                      </button>
                    </span>
                  ))}
                </div>
              )}
            </div>
            <div style={{
              background: colors.comeCard,
              border: '1px solid #333',
              borderRadius: '12px',
              padding: isMobile ? '12px' : '16px',
              marginBottom: '16px'
            }}>
              <button
                onClick={() => setIsStrainTypeExpanded(!isStrainTypeExpanded)}
                style={{
                  width: '100%',
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  background: 'none',
                  border: 'none',
                  cursor: 'pointer',
                  padding: '0',
                  marginBottom: isStrainTypeExpanded ? '12px' : '0'
                }}
              >
                <h4 style={{
                  margin: '0',
                  fontSize: isMobile ? '14px' : '16px',
                  fontWeight: '600',
                  color: '#e5e5e5'
                }}>
                  Shop by Type
                </h4>
                <ChevronDown 
                  size={20} 
                  style={{ 
                    color: '#888',
                    transform: isStrainTypeExpanded ? 'rotate(180deg)' : 'rotate(0deg)',
                    transition: 'transform 0.3s ease'
                  }} 
                />
              </button>
              
              {isStrainTypeExpanded && (
                <div style={{
                  display: 'grid',
                  gridTemplateColumns: 'repeat(3, 1fr)',
                  gap: '.5rem'
                }}>
                  {/* Indica */}
                  <div
                    onClick={() => {
                      const newType = strainType === 'Indica' ? null : 'Indica';
                      setStrainType(newType);
                      setActiveFilters(prev => ({
                        ...prev,
                        strainType: newType
                      }));
                      setCurrentPage(1);
                    }}
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      padding: '1rem',
                      borderRadius: '12px',
                      cursor: 'pointer',
                      backgroundColor: strainType === 'Indica' ? 'rgba(147, 51, 234, 0.2)' : 'rgba(147, 51, 234, 0.1)',
                      border: strainType === 'Indica' ? '2px solid #9333ea' : '2px solid transparent',
                      transition: 'all 0.2s ease'
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.backgroundColor = 'rgba(147, 51, 234, 0.2)';
                      e.currentTarget.style.borderColor = '#9333ea';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = strainType === 'Indica' ? 'rgba(147, 51, 234, 0.2)' : 'rgba(147, 51, 234, 0.1)';
                      e.currentTarget.style.borderColor = strainType === 'Indica' ? '#9333ea' : 'transparent';
                    }}
                  >
                    <svg width="60" height="60" viewBox="0 0 60 60">
                      <image 
                        href="https://highmind-bucket.s3.us-east-1.amazonaws.com/indica-removebg-preview.png" 
                        height="60" 
                        width="60" 
                        x="0" 
                        y="0" 
                      />
                    </svg>
                    <span style={{
                      fontSize: '0.875rem',
                      fontWeight: '600',
                      color: '#9333ea',
                      textAlign: 'center'
                    }}>
                      Indica
                    </span>
                    <span style={{
                      fontSize: '0.65rem',
                      color: '#888',
                      textAlign: 'center',
                      marginTop: '4px'
                    }}>
                      Relaxing
                    </span>
                  </div>

                  {/* Hybrid */}
                  <div
                    onClick={() => {
                      const newType = strainType === 'Hybrid' ? null : 'Hybrid';
                      setStrainType(newType);
                      setActiveFilters(prev => ({
                        ...prev,
                        strainType: newType
                      }));
                      setCurrentPage(1);
                    }}
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      padding: '1rem',
                      borderRadius: '12px',
                      cursor: 'pointer',
                      backgroundColor: strainType === 'Hybrid' ? 'rgba(16, 185, 129, 0.2)' : 'rgba(16, 185, 129, 0.1)',
                      border: strainType === 'Hybrid' ? '2px solid #10b981' : '2px solid transparent',
                      transition: 'all 0.2s ease'
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.backgroundColor = 'rgba(16, 185, 129, 0.2)';
                      e.currentTarget.style.borderColor = '#10b981';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = strainType === 'Hybrid' ? 'rgba(16, 185, 129, 0.2)' : 'rgba(16, 185, 129, 0.1)';
                      e.currentTarget.style.borderColor = strainType === 'Hybrid' ? '#10b981' : 'transparent';
                    }}
                  >
                    <svg width="60" height="60" viewBox="0 0 60 60">
                      <image 
                        href="https://highmind-bucket.s3.us-east-1.amazonaws.com/hybird (1).png" 
                        height="60" 
                        width="60" 
                        x="0" 
                        y="0" 
                      />
                    </svg>
                    <span style={{
                      fontSize: '0.875rem',
                      fontWeight: '600',
                      color: '#10b981',
                      textAlign: 'center'
                    }}>
                      Hybrid
                    </span>
                    <span style={{
                      fontSize: '0.65rem',
                      color: '#888',
                      textAlign: 'center',
                      marginTop: '4px'
                    }}>
                      Balanced
                    </span>
                  </div>

                  {/* Sativa */}
                  <div
                    onClick={() => {
                      const newType = strainType === 'Sativa' ? null : 'Sativa';
                      setStrainType(newType);
                      setActiveFilters(prev => ({
                        ...prev,
                        strainType: newType
                      }));
                      setCurrentPage(1);
                    }}
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      padding: '1rem',
                      borderRadius: '12px',
                      cursor: 'pointer',
                      backgroundColor: strainType === 'Sativa' ? 'rgba(245, 158, 11, 0.2)' : 'rgba(245, 158, 11, 0.1)',
                      border: strainType === 'Sativa' ? '2px solid #f59e0b' : '2px solid transparent',
                      transition: 'all 0.2s ease'
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.backgroundColor = 'rgba(245, 158, 11, 0.2)';
                      e.currentTarget.style.borderColor = '#f59e0b';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = strainType === 'Sativa' ? 'rgba(245, 158, 11, 0.2)' : 'rgba(245, 158, 11, 0.1)';
                      e.currentTarget.style.borderColor = strainType === 'Sativa' ? '#f59e0b' : 'transparent';
                    }}
                  >
                    <svg width="60" height="60" viewBox="0 0 60 60">
                      <image 
                        href="https://highmind-bucket.s3.us-east-1.amazonaws.com/sativa (2).png" 
                        height="60" 
                        width="60" 
                        x="0" 
                        y="0" 
                      />
                    </svg>
                    <span style={{
                      fontSize: '0.875rem',
                      fontWeight: '600',
                      color: '#f59e0b',
                      textAlign: 'center'
                    }}>
                      Sativa
                    </span>
                    <span style={{
                      fontSize: '0.65rem',
                      color: '#888',
                      textAlign: 'center',
                      marginTop: '4px'
                    }}>
                      Energizing
                    </span>
                  </div>
                </div>
              )}
              
              {/* Selected Strain Type Display */}
              {strainType && (
                <div style={{
                  marginTop: '12px',
                  display: 'flex',
                  flexWrap: 'wrap',
                  gap: '6px'
                }}>
                  <span style={{ fontSize: '12px', color: '#888', marginRight: '8px' }}>Selected Type:</span>
                  <span
                    style={{
                      background: strainType === 'Indica' ? 'rgba(147, 51, 234, 0.2)' :
                                  strainType === 'Hybrid' ? 'rgba(16, 185, 129, 0.2)' :
                                  'rgba(245, 158, 11, 0.2)',
                      color: strainType === 'Indica' ? '#9333ea' :
                            strainType === 'Hybrid' ? '#10b981' :
                            '#f59e0b',
                      padding: '2px 8px',
                      borderRadius: '8px',
                      fontSize: '10px',
                      fontWeight: '600',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '4px'
                    }}
                  >
                    {strainType}
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        setStrainType(null);
                      }}
                      style={{
                        background: 'none',
                        border: 'none',
                        color: 'inherit',
                        cursor: 'pointer',
                        padding: '0',
                        fontSize: '12px',
                        fontWeight: 'bold'
                      }}
                    >
                      ×
                    </button>
                  </span>
                </div>
              )}
            </div>

            {/* Quick Filters */}
            <div className="mobile-quick-filters" style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
              {['🔥 Popular', '⭐ Top Rated', '🆕 New Arrivals', '💰 Best Deals', '🌿 High THC', '😴 Sleep Aid'].map((filter, index) => (
                <button
                  key={filter}
                  style={{
                    padding: isMobile ? '6px 12px' : '8px 16px',
                    background: index === 0 ? colors.filterActiveGradient : colors.filterInactiveBackground,
                    color: index === 0 ? colors.filterActiveText : colors.filterInactiveText,
                    border: '1px solid',
                    borderColor: index === 0 ? colors.filterActiveBorder : colors.filterInactiveBorder,
                    borderRadius: '12px',
                    cursor: 'pointer',
                    fontSize: isMobile ? '11px' : '12px',
                    fontWeight: '500',
                    transition: 'all 0.3s ease',
                    flex: isMobile ? '1 1 auto' : 'none',
                    minWidth: isMobile ? '100px' : 'auto'
                  }}
                  onMouseEnter={(e) => {
                    if (index !== 0) {
                      e.currentTarget.style.background = colors.filterHoverGradient;
                      e.currentTarget.style.borderColor = colors.filterHoverBorder;
                      e.currentTarget.style.color = colors.filterHoverText;
                    }
                  }}
                  onMouseLeave={(e) => {
                    if (index !== 0) {
                      e.currentTarget.style.background = colors.filterInactiveBackground;
                      e.currentTarget.style.borderColor = colors.filterInactiveBorder;
                      e.currentTarget.style.color = colors.filterInactiveText;
                    }
                  }}
                >
                  {filter}
                </button>
              ))}
            </div>
          </div>
        </div>

        {/* Main Layout */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: isMobile ? '1fr' : '300px 1fr',
          gap: isMobile ? '0' : '32px'
        }}>
          {/* Left Sidebar - Desktop or Mobile Filter */}
          {!isMobile ? (
            <aside>
              <FilterSidebar 
                activeFilters={activeFilters}
                onFilterChange={(newFilters) => {
                  setActiveFilters(newFilters);
                  // Sync strainType state when activeFilters changes
                  if (newFilters.strainType !== strainType) {
                    setStrainType(newFilters.strainType);
                  }
                }}
                sortBy={sortBy}
                onSortChange={setSortBy}
                isOpen={isFilterOpen}
                onClose={() => setIsFilterOpen(false)}
                colors={colors}
              />
              <TrendingSidebar onSearchClick={handleTrendingSearch} />
              <DealsAlert />
            </aside>
          ) : (
            <FilterSidebar 
              activeFilters={activeFilters}
              onFilterChange={setActiveFilters}
              sortBy={sortBy}
              onSortChange={setSortBy}
              isOpen={isFilterOpen}
              onClose={() => setIsFilterOpen(false)}
              colors={colors}
            />
          )}

          {/* Products Grid */}
          <main>
            {/* Mobile Filter Toggle Button */}
            {isMobile && (
              <div style={{ marginBottom: '20px' }}>
                <button
                  onClick={() => setIsFilterOpen(true)}
                  style={{
                    width: '100%',
                    padding: '12px 16px',
                    background: 'linear-gradient(135deg, #2a2a2a 0%, #1f1f1f 100%)',
                    color: '#e5e5e5',
                    border: '1px solid #333',
                    borderRadius: '12px',
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '8px',
                    fontSize: '14px',
                    fontWeight: '600',
                    transition: 'all 0.3s ease'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.background = 'linear-gradient(135deg, #00d4aa 0%, #10b981 100%)';
                    e.currentTarget.style.color = '#0a0a0a';
                    e.currentTarget.style.borderColor = '#00d4aa';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.background = 'linear-gradient(135deg, #2a2a2a 0%, #1f1f1f 100%)';
                    e.currentTarget.style.color = '#e5e5e5';
                    e.currentTarget.style.borderColor = '#333';
                  }}
                >
                  <Filter size={16} />
                  Filters & Sort
                </button>
              </div>
            )}

            {/* Results Header */}
            <div className="mobile-results-header" style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: isMobile ? 'flex-start' : 'center',
              marginBottom: '24px',
              padding: '16px 0',
              flexDirection: isMobile ? 'column' : 'row',
              gap: isMobile ? '16px' : '0'
            }}>
              <div>
                <h2 style={{
                  margin: 0,
                  fontSize: isMobile ? '18px' : '20px',
                  fontWeight: '600',
                  color: '#e5e5e5'
                }}>
                  {totalProducts.toLocaleString()} Products Found
                </h2>
                <p style={{
                  margin: '4px 0 0 0',
                  fontSize: isMobile ? '12px' : '14px',
                  color: '#888'
                }}>
                  {searchTerm ? `Results for "${searchTerm}"` : 'Showing all products'} • Page {currentPage} of {totalPages}
                </p>
              </div>

              <div style={{ display: 'flex', alignItems: 'center', gap: '12px', flexWrap: isMobile ? 'wrap' : 'nowrap' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <span style={{ color: '#888', fontSize: isMobile ? '12px' : '14px' }}>Show:</span>
                  <select
                    value={perPage}
                    onChange={(e) => {
                      setPerPage(Number(e.target.value));
                      setCurrentPage(1);
                    }}
                    style={{
                      padding: '6px 10px',
                      backgroundColor: '#2a2a2a',
                      border: '1px solid #333',
                      borderRadius: '6px',
                      color: '#e5e5e5',
                      fontSize: isMobile ? '12px' : '14px',
                      cursor: 'pointer'
                    }}
                  >
                    <option value={10}>10</option>
                    <option value={20}>20</option>
                    <option value={50}>50</option>
                  </select>
                </div>

                <select
                  value={sortBy}
                  onChange={(e) => setSortBy(e.target.value)}
                  style={{
                    padding: '8px 12px',
                    backgroundColor: '#2a2a2a',
                    border: '1px solid #333',
                    borderRadius: '8px',
                    color: '#e5e5e5',
                    fontSize: isMobile ? '12px' : '14px',
                    cursor: 'pointer'
                  }}
                >
                  <option value="rating">⭐ Top Rated</option>
                  <option value="newest">🆕 Newest</option>
                  <option value="price-low">💰 Price: Low</option>
                  <option value="price-high">💰 Price: High</option>
                  <option value="distance">📍 Nearest</option>
                </select>
              </div>
            </div>

            {/* Products Grid */}
            <div style={{
              display: 'grid',
              gridTemplateColumns: isMobile ? 'repeat(auto-fit, minmax(160px, 1fr))' : 'repeat(auto-fit, minmax(280px, 1fr))',
              gap: isMobile ? '16px' : '24px'
            }}>
              {filteredProducts.map((product, index) => (
                <div key={product.id} className="slide-up" style={{
                  animationDelay: `${index * 0.1}s`
                }}>
                  <EnhancedProductCard
                    product={product}
                    onWishlist={handleWishlist}
                    onQuickView={handleQuickView}
                    colors={colors}
                  />
                </div>
              ))}
            </div>

            {/* Pagination */}
            {totalPages > 1 && (
              <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: isMobile ? 'flex-start' : 'center',
                marginTop: '32px',
                padding: isMobile ? '16px' : '24px',
                background: colors.comeCard,
                borderRadius: '16px',
                border: '1px solid #333',
                flexDirection: isMobile ? 'column' : 'row',
                gap: isMobile ? '16px' : '0'
              }}>
                <div style={{ color: '#888', fontSize: isMobile ? '12px' : '14px' }}>
                  Showing {((currentPage - 1) * perPage) + 1}-{Math.min(currentPage * perPage, totalProducts)} of {totalProducts.toLocaleString()} products
                </div>
                
                <div className="mobile-pagination-controls" style={{ 
                  display: 'flex', 
                  gap: '4px', 
                  alignItems: 'center',
                  flexDirection: isMobile ? 'column' : 'row',
                  width: isMobile ? '100%' : 'auto'
                }}>
                  {/* Navigation Buttons */}
                  <div style={{ display: 'flex', gap: '4px', marginBottom: isMobile ? '8px' : '0' }}>
                    <button
                      onClick={() => setCurrentPage(1)}
                      disabled={!hasPrev}
                      style={{
                        padding: isMobile ? '6px 10px' : '8px 12px',
                        background: hasPrev ? 'linear-gradient(135deg, #333 0%, #444 100%)' : '#222',
                        color: hasPrev ? '#ccc' : '#555',
                        border: 'none',
                        borderRadius: '8px',
                        cursor: hasPrev ? 'pointer' : 'not-allowed',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '4px',
                        fontSize: isMobile ? '12px' : '14px',
                        fontWeight: '500',
                        transition: 'all 0.2s ease'
                      }}
                    >
                      {!isMobile && 'Next'}
                      <ChevronRight size={isMobile ? 14 : 16} />
                    </button>
                    
                    <button
                      onClick={() => setCurrentPage(totalPages)}
                      disabled={!hasNext}
                      style={{
                        padding: isMobile ? '6px 10px' : '8px 12px',
                        background: hasNext ? 'linear-gradient(135deg, #333 0%, #444 100%)' : '#222',
                        color: hasNext ? '#ccc' : '#555',
                        border: 'none',
                        borderRadius: '8px',
                        cursor: hasNext ? 'pointer' : 'not-allowed',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '4px',
                        fontSize: isMobile ? '12px' : '14px',
                        fontWeight: '500',
                        transition: 'all 0.2s ease'
                      }}
                    >
                      {!isMobile && 'Last'}
                      <ChevronsRight size={isMobile ? 14 : 16} />
                    </button>
                  </div>
                  
                  {/* Page Numbers */}
                  <div className="mobile-page-numbers" style={{ 
                    display: 'flex', 
                    gap: '2px', 
                    alignItems: 'center', 
                    margin: isMobile ? '0' : '0 12px',
                    flexWrap: isMobile ? 'wrap' : 'nowrap',
                    justifyContent: isMobile ? 'center' : 'flex-start'
                  }}>
                    {Array.from({ length: Math.min(isMobile ? 3 : 5, totalPages) }, (_, i) => {
                      let pageNum;
                      if (totalPages <= (isMobile ? 3 : 5)) {
                        pageNum = i + 1;
                      } else if (currentPage <= (isMobile ? 2 : 3)) {
                        pageNum = i + 1;
                      } else if (currentPage >= totalPages - (isMobile ? 1 : 2)) {
                        pageNum = totalPages - (isMobile ? 2 : 4) + i;
                      } else {
                        pageNum = currentPage - (isMobile ? 1 : 2) + i;
                      }
                      
                      return (
                        <button
                          key={pageNum}
                          onClick={() => setCurrentPage(pageNum)}
                          style={{
                            padding: isMobile ? '8px 10px' : '10px 14px',
                            background: pageNum === currentPage 
                              ? 'linear-gradient(135deg, #00d4aa 0%, #10b981 100%)' 
                              : 'linear-gradient(135deg, #333 0%, #444 100%)',
                            color: pageNum === currentPage ? '#0a0a0a' : '#ccc',
                            border: 'none',
                            borderRadius: '8px',
                            fontSize: isMobile ? '12px' : '14px',
                            fontWeight: '600',
                            cursor: 'pointer',
                            minWidth: isMobile ? '32px' : '40px',
                            transition: 'all 0.2s ease'
                          }}
                          onMouseEnter={(e) => {
                            if (pageNum !== currentPage) {
                              e.currentTarget.style.background = 'linear-gradient(135deg, #00d4aa 0%, #10b981 100%)';
                              e.currentTarget.style.color = '#0a0a0a';
                            }
                          }}
                          onMouseLeave={(e) => {
                            if (pageNum !== currentPage) {
                              e.currentTarget.style.background = 'linear-gradient(135deg, #333 0%, #444 100%)';
                              e.currentTarget.style.color = '#ccc';
                            }
                          }}
                        >
                          {pageNum}
                        </button>
                      );
                    })}
                    
                    {totalPages > (isMobile ? 3 : 5) && currentPage < totalPages - (isMobile ? 1 : 2) && (
                      <>
                        <span style={{ color: '#666', margin: '0 8px', fontSize: isMobile ? '12px' : '14px' }}>...</span>
                        <button
                          onClick={() => setCurrentPage(totalPages)}
                          style={{
                            padding: isMobile ? '8px 10px' : '10px 14px',
                            background: 'linear-gradient(135deg, #333 0%, #444 100%)',
                            color: '#ccc',
                            border: 'none',
                            borderRadius: '8px',
                            fontSize: isMobile ? '12px' : '14px',
                            fontWeight: '600',
                            cursor: 'pointer',
                            minWidth: isMobile ? '32px' : '40px',
                            transition: 'all 0.2s ease'
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.background = 'linear-gradient(135deg, #00d4aa 0%, #10b981 100%)';
                            e.currentTarget.style.color = '#0a0a0a';
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.background = 'linear-gradient(135deg, #333 0%, #444 100%)';
                            e.currentTarget.style.color = '#ccc';
                          }}
                        >
                          {totalPages}
                        </button>
                      </>
                    )}
                  </div>
                </div>
              </div>
            )}
          </main>
        </div>
      </div>

      {/* Modals */}
      <ProductSubmissionModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onSubmit={handleProductSubmission}
      />
      <DispensarySubmissionModal
        isOpen={isDispensaryModalOpen}
        onClose={() => setIsDispensaryModalOpen(false)}
        onSubmit={handleDispensarySubmission}
      />
      <FindNearbyModal
        isOpen={isFindNearbyModalOpen}
        onClose={() => setIsFindNearbyModalOpen(false)}
        onDispensarySelect={handleDispensarySelect}
        url={url}
      />
    </div>
  );
}